import { Component, OnInit } from '@angular/core';
import { ApproverService } from '../../../services/approver.service';
import { ToastService } from '../../../services/toast.service';
import { Approver, ApproverRequest, ApproverModules } from '../../../interfaces/approver.interfaces';

@Component({
  selector: 'app-approvers',
  templateUrl: './approvers.component.html',
  styleUrl: './approvers.component.scss'
})
export class ApproversComponent implements OnInit {

  approvers: Approver[] = [];
  isLoading = true;
  loadError = false;

  showFormDialog = false;
  isEditing = false;
  editingId = 0;
  isSaving = false;

  formData: ApproverRequest = {
    email: '',
    fullName: '',
    module: ApproverModules.INCOME_RECEIPTS,
    isActive: true,
    notes: ''
  };

  moduleOptions = [
    { label: 'Comprobantes de Ingreso', value: ApproverModules.INCOME_RECEIPTS },
    { label: 'Comprobantes de Egreso', value: ApproverModules.EXPENSE_VOUCHERS },
    { label: 'Comprobantes de Devolución', value: ApproverModules.REFUND_VOUCHERS }
  ];

  showDeleteConfirm = false;
  deletingApprover: Approver | null = null;

  constructor(
    private approverService: ApproverService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.loadApprovers();
  }

  loadApprovers(): void {
    this.isLoading = true;
    this.loadError = false;

    this.approverService.getAll().subscribe({
      next: (response: any) => {
        this.approvers = response.data || [];
        this.isLoading = false;
      },
      error: () => {
        this.loadError = true;
        this.isLoading = false;
        this.toastService.showToast('error', 'Error al cargar los aprobadores');
      }
    });
  }

  openNewDialog(): void {
    this.isEditing = false;
    this.editingId = 0;
    this.formData = {
      email: '',
      fullName: '',
      module: ApproverModules.INCOME_RECEIPTS,
      isActive: true,
      notes: ''
    };
    this.showFormDialog = true;
  }

  openEditDialog(approver: Approver): void {
    this.isEditing = true;
    this.editingId = approver.id;
    this.formData = {
      email: approver.email,
      fullName: approver.fullName,
      module: approver.module,
      isActive: approver.isActive,
      notes: approver.notes || ''
    };
    this.showFormDialog = true;
  }

  closeDialog(): void {
    this.showFormDialog = false;
    this.editingId = 0;
  }

  saveApprover(): void {
    if (!this.formData.email || !this.formData.module) {
      this.toastService.showToast('warning', 'Email y módulo son obligatorios');
      return;
    }

    this.isSaving = true;

    const operation = this.isEditing
      ? this.approverService.update(this.editingId, this.formData)
      : this.approverService.insert(this.formData);

    operation.subscribe({
      next: () => {
        const action = this.isEditing ? 'actualizado' : 'creado';
        this.toastService.showToast('success', `Aprobador ${action} exitosamente`);
        this.isSaving = false;
        this.showFormDialog = false;
        this.loadApprovers();
      },
      error: () => {
        this.toastService.showToast('error', 'Error al guardar el aprobador');
        this.isSaving = false;
      }
    });
  }

  confirmDelete(approver: Approver): void {
    this.deletingApprover = approver;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.deletingApprover = null;
  }

  deleteApprover(): void {
    if (!this.deletingApprover) return;

    this.approverService.delete(this.deletingApprover.id).subscribe({
      next: () => {
        this.toastService.showToast('success', 'Aprobador eliminado exitosamente');
        this.showDeleteConfirm = false;
        this.deletingApprover = null;
        this.loadApprovers();
      },
      error: () => {
        this.toastService.showToast('error', 'Error al eliminar el aprobador');
      }
    });
  }

  getModuleLabel(module: string): string {
    const option = this.moduleOptions.find(o => o.value === module);
    return option?.label || module;
  }
}
